import React from 'react'
import BaseIcon from 'react-icon-base'

const SendPhoneForVarification = props => (
  <BaseIcon width="144" height="107" viewBox="0 0 144 107" {...props}>
    <defs>
      <filter
        id="aSendPhoneForVarification"
        width="133.3%"
        height="149.4%"
        x="-16.7%"
        y="-24.7%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="4" />
        <feColorMatrix
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
          values="0 0 0 0 0.851482781 0 0 0 0 0.851482781 0 0 0 0 0.851482781 0 0 0 0.5 0"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd">
      <g fillRule="nonzero" filter="url(#aSendPhoneForVarification)" transform="translate(8 16)">
        <path fill="#2AB8FF" d="M0 .934h120v79.868H0z" />
        <path fill="#23CF9D" d="M60 40.868l60 39.934H0z" />
        <path fill="#2ED8A7" d="M60 40.868L0 80.802V.934zM60 41.038l59.5-39.934v79.868z" />
        <path fill="#34E4B1" d="M60 60.868L0 .934h120z" />
      </g>
      <g transform="translate(112)">
        <circle cx="16" cy="16" r="16" fill="#FF8484" />
        <text fill="#FFF" fontFamily="Roboto-Bold, Roboto" fontSize="16" fontWeight="bold">
          <tspan x="13.824" y="20">
            !
          </tspan>
        </text>
      </g>
    </g>
  </BaseIcon>
)

export default SendPhoneForVarification
